import React from 'react'
import translate from '../../../../modules/translate/index'
import Tabs from '../../../../components/Tabs/index'
import TabsItem from '../../../../components/TabsItem/index'
import Prognosis from './screens/ScreenPrognosis/index'
import MountainWeather from './screens/ScreenMountainWeather/index'
import RadarRainfall from './screens/ScreenRadarRainfall/index'
import ForecastAvalanche from './screens/ScreenAvalanche/index'
import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import namedRoutes from '../../../../config/routes'
import isServerSide from '../../../../modules/is-server-side'

const ScreenWeather = ({ location, response, loading, failed, ...props }) => {
  const value = location ? location.pathname : !isServerSide() && window.location && window.location.pathname

  const data = response && response.data
  const meta = response && response.meta

  return (
    <React.Fragment>
      <Tabs value={value} switchscrollablefrom={416}>
        <TabsItem label={translate('weather_forecast')} value={namedRoutes['weather'].path} />
        <TabsItem label={translate('weather_mountain')} value={namedRoutes['weather.mountain'].path} />
        <TabsItem label={translate('weather_rainfall_radar')} value={namedRoutes['weather.rainfall_radar'].path} />
        {data.avalancheReportAvailable && (
          <TabsItem label={translate('weather_avalanche')} value={namedRoutes['weather.avalanche'].path} />
        )}
      </Tabs>
      <Switch location={location}>
        <Route
          {...namedRoutes['weather']}
          render={(props) => (
            <Prognosis
              data={data}
              loading={loading}
              failed={failed}
              adTargeting={meta && meta.adsTargeting}
              {...props}
            />
          )}
        />
        <Route
          {...namedRoutes['weather.mountain']}
          render={(props) => <MountainWeather data={data} loading={loading} failed={failed} {...props} />}
        />
        <Route
          {...namedRoutes['weather.rainfall_radar']}
          render={(props) => <RadarRainfall data={data} loading={loading} failed={failed} {...props} />}
        />
        <Route
          {...namedRoutes['weather.avalanche']}
          render={(props) => <ForecastAvalanche data={data} loading={loading} failed={failed} {...props} />}
        />
      </Switch>
    </React.Fragment>
  )
}

export default ScreenWeather
